import type {
  QueryRankingElementRankingDTO,
  QueryRankingHiddenElementDTO,
  QueryRankingPinnedElementDTO,
} from '@empathyco/playboard-core-domain'
import type { Mapper } from '@empathyco/x-adapter'
import type { SearchRequest } from '@empathyco/x-types'
import type { ExtraParamsRaw, PlaySearchRequest } from '../types'
import { schemaMapperFactory } from '@empathyco/x-adapter'
import { searchRequestSchema } from '../schemas/search-request.schema'

export const searchRequestMapper: Mapper<SearchRequest, PlaySearchRequest> = (from, context) => {
  const { queryRanking, ...extraParamsRaw } = from.extraParams.raw ?? {}
  return {
    ...from.extraParams.filters,
    ...extraParamsRaw,
    ...(queryRanking && mapQueryRankingExtraParams(queryRanking)),
    ...schemaMapperFactory(searchRequestSchema)(from, context),
    internal: true,
  }
}

function mapQueryRankingExtraParams(
  params: ExtraParamsRaw['queryRanking'],
): Pick<
  PlaySearchRequest,
  | 'productsRankingField'
  | 'productsRankingBoostsIds'
  | 'productsRankingBuriesIds'
  | 'attributesRankingBoosts'
  | 'attributesRankingBuries'
  | 'attributesHidden'
  | 'pinnedProducts'
  | 'productsHiddenIds'
> {
  const mapProducts = (productRanking: QueryRankingElementRankingDTO): string =>
    productRanking.fieldValue
  const mapAttributes = (attributeRanking: QueryRankingElementRankingDTO): string =>
    `${attributeRanking.fieldName}:${attributeRanking.fieldValue}`

  const mapPinnedElements = (pinnedElements: QueryRankingPinnedElementDTO): string =>
    `${pinnedElements.fieldValue}:${pinnedElements.position}`

  const mapHiddenAttributes = (hiddenAttributes: QueryRankingHiddenElementDTO): string =>
    `${hiddenAttributes.fieldName}:${hiddenAttributes.fieldValue}`

  return {
    productsRankingField: params?.products?.fieldName || '',
    productsRankingBoostsIds: params?.products?.boosted.map(mapProducts).join(',') || '',
    productsRankingBuriesIds: params?.products?.buried.map(mapProducts).join(',') || '',
    attributesRankingBoosts: params?.attributes?.boosted.map(mapAttributes).join(',') || '',
    attributesRankingBuries: params?.attributes?.buried.map(mapAttributes).join(',') || '',
    attributesHidden: params?.hiddenAttributes?.map(mapHiddenAttributes).join(',') || '',
    pinnedProducts: params?.pinnedElements?.map(mapPinnedElements).join(',') || '',
  }
}
